function o(e, t) {
  let r = t.pop(), l = t.reduce((n, d) => n[d] || {}, e);
  return delete l[r], e;
}
export {
  o as deleteFromObjectByPath
};
